import { pinyin } from 'pinyin-pro';

// 获取完整大小单位
const fixRoiSize = size => {
  if (size > 1000 * 1224) {
    return { uni: 'MB', size: (size / (1024 * 1000)).toFixed(0) };
  } else {
    return { uni: 'KB', size: (size / 1024).toFixed(0) };
  }
};

// 获取完整图片地址
const onGetImageUrl = url => {
  if (!url) return '';
  if (url.includes('http')) return url;
  // 如果是本地开发 使用 固定IP，如果是线上版本则使用浏览器地址
  if (process.env.NODE_ENV === 'development') {
    return 'http://ippconsole.com/api/' + url;
  } else {
    if (window !== window.top) {
      // 获取子页面自身的域名相关信息
      const subDomain = {
        hostname: window.location.hostname, // 域名（不含端口）
        host: window.location.host, // 域名+端口
        origin: window.location.origin // 完整源（协议+域名+端口）
      };

      console.log('子页面自身域名（hostname）：', subDomain.hostname);
      console.log('子页面完整 host（域名+端口）：', subDomain.host);
      console.log('子页面完整 origin：', subDomain.origin);

      const roiUrl = window.location.origin + '/api/' + url;

      // 原字符串中需要替换的部分
      const original = 'https://hysjzx.gzlpc.gov.cn/api/';
      // 替换后的新内容
      const replacement = 'https://hysjzx.gzlpc.gov.cn/fyswtp/api/';
      // 执行替换（使用正则确保全局替换所有匹配项）
      return roiUrl.replace(new RegExp(original, 'g'), replacement);
    }

    return window.location.origin + '/api/' + url;
  }
};

// 首字母排序
const sortByFirstLetter = (arr, title = 'title', sort = 'asc') => {
  if (!arr) return [];
  const a = arr.sort((a, b) => {
    const pinyinA = pinyin(a[title][0], { pattern: 'first' }).toUpperCase();
    const pinyinB = pinyin(b[title][0], { pattern: 'first' }).toUpperCase();
    if (pinyinA < pinyinB) {
      return sort === 'asc' ? -1 : 1;
    }
    if (pinyinA > pinyinB) {
      return sort === 'asc' ? 1 : -1;
    }
    return 0;
  });

  return a;
};

// 计算布局：传入区域宽高、基准高度（默认100），返回方块尺寸、行列数、总数量
const calcLayout = (width, height, baseHeight = 100) => {
  if (!width || !height) {
    return { blockH: 100, blockW: 100, rowNum: 1, colNum: 1, limit: 1 };
  }

  // 1. 根据基准高度计算行数（向下取整）
  const rowNum = Math.max(1, Math.floor(height / baseHeight));

  // 2. 得到准确的方块高度
  const blockHeight = height / rowNum;

  // 3. 在尽可能正方形的前提下，根据宽度计算列数
  const colNum = Math.max(1, Math.round(width / blockHeight));

  // 4. 调整方块宽度使其完全铺满
  const blockWidth = width / colNum;

  // 5. 方块宽高各自向下取整
  const blockH = Math.floor(blockHeight);
  const blockW = Math.floor(blockWidth);

  // 6. 计算总方块数
  const limit = rowNum * colNum;

  return { blockH, blockW, rowNum, colNum, limit };
};

export default {
  fixRoiSize,
  sortByFirstLetter,
  onGetImageUrl,
  calcLayout
};
